import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import Badge from './Badge.js';
export const ExclusiveContent = (props) => {
    const me = useSelector(selectMe);
    const exclusiveContent = useSelector(selectExclusiveContent);
    return (React.createElement(React.Fragment, null, me && exclusiveContent && exclusiveContent.includes(me.id)
        ? props.children
        : props.fallback != null
            ? React.createElement(props.fallback)
            : null));
};
export default ExclusiveContent;
export const ExclusiveContentBadge = () => {
    const exclusiveContent = useSelector(selectExclusiveContent);
    const me = useSelector(selectMe);
    return (React.createElement(Badge, { theme: me && exclusiveContent?.includes(me.id)
            ? THEME.COLOR_ACCENT
            : THEME.COLOR_GREY, style: { fontWeight: 900, verticalAlign: 'middle' } }, "Exclusive Content"));
};
//# sourceMappingURL=ExclusiveContent.js.map